export default "__VITE_ASSET__MWdMr1RP__"